import { api, post } from '../../service';

const installDevice = {
    namespaced: true,
    state: {
        search: {
            size: 10,
            page: 1,
        },
        total: 0,
        devices: [],
        selection: [],
    },
    actions: {
        async getDevices({ commit, state }, data) {
            const params = { ...state.search, ...data };
            await post(api.device.list, params);
            // commit('changeDevices', data);
        },
        async getLabelList({ commit }, data) {
            const res = await post(api.resource.labelList, data);
            return res;
        },
        async getFileList({ commit }, data) {
            const res = await post(api.resource.fileList, data);
            return res;
        },
        async resetDevice({ commit, state }, data) {
            await post(api.device.reset, data);
        },
        changeSearch({ commit }, data) {
            commit('changeSearch', data);
        },
        changeSelection({ commit }, data) {
            commit('changeSelection', data);
        },
    },
    mutations: {
        changeDevices(state, data) {
            state.total = data.totalCount;
            state.devices = data.devices;
        },
        changeSearch(state, data) {
            Object.assign(state.search, data);
        },
        changeSelection(state, data) {
            state.selection = data;
        },
    },
};

export default installDevice;
